import { ILookupList, IStateLookupList } from '../../../App/global/models/lookup-list';
import { isNullOrUndefined } from 'util';
import { createEvent } from '../helpers/eventCreator';

interface IStateDropdown {
    countrySelect: HTMLSelectElement;
    stateSelect: HTMLSelectElement;
    states: IStateLookupList[];
    selectPlaceholder: string;
    onCountryChange(statesExist: boolean): void;
}

const formElementRequiredClass = "form-element-required";
const formElementInvalidClass = "form-element-invalid";
const labelClass = ".form-element-label-sub";
const requiredText = "Required";
const optionalText = "Optional";

export class StateDropdownChanger implements IStateDropdown {
    countrySelect: HTMLSelectElement;
    stateSelect: HTMLSelectElement;
    postalCodeInput: HTMLInputElement;
    states: IStateLookupList[];
    selectPlaceholder: string;

    constructor() {
        let dynamicStatePage = document.getElementsByClassName("dynamic-states")
        if (!dynamicStatePage || dynamicStatePage.length < 1) {
            return;
        }

        this.countrySelect = document.querySelector("[data-dynamic-states-country]") as HTMLSelectElement;
        this.stateSelect = document.querySelector("[data-dynamic-states-state]") as HTMLSelectElement;
        this.postalCodeInput = document.querySelector("[data-dynamic-postal-code-validation]") as HTMLInputElement;
        this.states = (window as any).bootstrap.states;
        this.selectPlaceholder = (window as any).bootstrap.selectPlaceholder;

        let statesExist = !isNullOrUndefined(this.countrySelect) && !isNullOrUndefined(this.stateSelect) && !isNullOrUndefined(this.states) && this.states.length > 0;

        if (statesExist) {
            this.onLoad();
        }

        this.countrySelect.addEventListener('change', () => this.onCountryChange(statesExist));
    }

    onLoad = () => {
        let selectedCountry = this.countrySelect.value;
        let selectedState = this.stateSelect.value;
        let matchedStates = this.states.filter(s => s.countryCode === selectedCountry);

        if (!selectedCountry) {
            this.stateSelect.disabled = true;
            this.stateSelect.required = true;
            this.setRequired(true);
        }
        // if country is selected, set state options and select existing state if one is selected
        else if (matchedStates.length > 0) {
            this.stateSelect.disabled = false;
            this.stateSelect.required = true;
            this.setRequired(true);

            this.removeStateOptions();
            this.addPlaceholder();
            this.addOptions(matchedStates, selectedState);
        }
        else {
            this.stateSelect.disabled = true;
            this.stateSelect.required = false;
            this.setRequired(false);
        }
    }


    onCountryChange = (statesExist: boolean) => {
        let selectedCountry = this.countrySelect.value;

        if (this.postalCodeInput && this.postalCodeInput.value) {
            var blurEvent = createEvent('blur');
            this.postalCodeInput.dispatchEvent(blurEvent);
        }

        if (!statesExist) {
            return;
        }
        let matchedStates = this.states.filter(s => s.countryCode === selectedCountry);
        this.removeStateOptions();
        this.addPlaceholder();

        // if no selected country, disable states but keep it required
        if (!selectedCountry) {
            this.stateSelect.disabled = true;
            this.stateSelect.required = true;
            this.setRequired(true);
        }
        // if country is selected and there are matching states, enable and keep it required + update the state options
        else if (matchedStates && matchedStates.length > 0) {
            this.stateSelect.disabled = false;
            this.stateSelect.required = true;
            this.setRequired(true);

            this.addOptions(matchedStates);
        }
        // if the country doesn't have any matching states, disable and mark as optional
        else if (selectedCountry && (!matchedStates || matchedStates.length < 1)) {
            this.stateSelect.disabled = true;
            this.stateSelect.required = false;
            this.setRequired(false);
        }
    }

    removeStateOptions = () => {
        for (let i = this.stateSelect.options.length - 1; i >= 0; i--) {
            this.stateSelect.remove(i);
        }
    }

    addPlaceholder = () => {
        let placeHolder: HTMLOptionElement = document.createElement('option');
        placeHolder.value = "";
        placeHolder.text = this.selectPlaceholder ? this.selectPlaceholder : "Select One";
        this.stateSelect.appendChild(placeHolder);
    }

    setRequired = (required: boolean) => {
        let formElement = (this.stateSelect.parentNode as HTMLElement);

        if (required) {
            formElement.classList.add(formElementRequiredClass);
            formElement.querySelector(labelClass).innerHTML = requiredText;
        }
        else {
            formElement.classList.remove(formElementRequiredClass);
            formElement.classList.remove(formElementInvalidClass);
            formElement.querySelector(labelClass).innerHTML = optionalText;
        }
    }

    addOptions = (options: IStateLookupList[], selectedState?: string) => {
        options.forEach(s => {
            let option: HTMLOptionElement = document.createElement('option');
            option.value = s.code;
            option.text = s.code;
            option.selected = selectedState ? option.value === selectedState : false;
            this.stateSelect.appendChild(option);
        })
    }
}




